import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ui-divider',
  standalone: true,
  imports: [],
  templateUrl: './divider.component.html',
  styleUrls: ['./divider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DividerComponent {}
